export default "__VITE_ASSET__pOuA6Cgw0Hs2VRp4syQvcg__";